import { render, staticRenderFns } from "./dgSchemeDetail.vue?vue&type=template&id=38bab174&"
import script from "./dgSchemeDetail.vue?vue&type=script&lang=js&"
export * from "./dgSchemeDetail.vue?vue&type=script&lang=js&"
import style0 from "./dgSchemeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bab174')) {
      api.createRecord('38bab174', component.options)
    } else {
      api.reload('38bab174', component.options)
    }
    module.hot.accept("./dgSchemeDetail.vue?vue&type=template&id=38bab174&", function () {
      api.rerender('38bab174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/costPlan/dgSchemeDetail.vue"
export default component.exports